export default "__VITE_ASSET__47f94ab2__"